const React = require('react');

module.exports = React.createClass({
	
	render(){
		var className = 'btn btn-'+(this.props.className || 'primary');
		var icon;

		if (this.props.icon) {
			icon = <span className={'glyphicon glyphicon-'+this.props.icon} />
		}

		return (
			<button {...this.props} className={className} >
				{icon}
				{this.props.children}
			</button>	
		);
	}

});


/** WEBPACK FOOTER **
 ** ./src/components/button.js
 **/